import { useParams} from 'react-router-dom';
// import {useState} from 'react';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import useMediaQuery from '@material-ui/core/useMediaQuery'
import ReactFontLoader from 'react-font-loader';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import {getBlogs,updateBlog,deleteComment} from "../actions/blogs";
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Loading from "./loading"
const useStyles = makeStyles((theme) => ({

    rootdiv:{
        display:'flex',
        alignItems: 'flex-start',
        justifyContent:'center',
        justifyItems:'center',
        overflowX:'hidden'

    },
    rootdivphone:{
        display:'flex',
        flexDirection:'column',
        alignItems: 'flex-start',
        justifyContent:'center',
        justifyItems:'center',
        overflowX:'hidden'
    },

    adminIcon:{
        marginLeft: '5vh',
        // background:'#09417c',
        // padding:'0.8vh',
        marginTop:'3vh',
        marginBottom:'3vh'
    },
    adminiconmobile:{
        marginLeft: '2vh',
        // background:'#09417c',
        // padding:'0.8vh',
        marginTop:'3vh',
        marginBottom:'0vh'
    },
    blogbody:{
        width:'100%',
    },
    bodypaper:{
        width:'90%',
        marginLeft:'1vh',
        marginRight:'5vh',
        marginTop:'3vh',
        marginBottom:'3vh',
        paddingBottom:'1vh',
        overflowX:'hidden'
    },

    commentdiv:{
        display:'flex',
        alignItems: 'flex-start',
        justifyContent:'flex-start',
        justifyItems:'flex-start',
        marginTop: '5vh',
        marginBottom:'5vh',
        marginLeft:'1vh',
        overflowX:'hidden'

    },
    commentdivmob:{
        display:'flex',
        alignItems: 'flex-start',
        flexDirection:'column',
        justifyContent:'flex-start',
        justifyItems:'flex-start',
        marginTop: '5vh',
        marginBottom:'5vh',
        marginLeft:'1vh',
        overflowX:'hidden'

    },
    commenticon:{
        fontSize:'11vh',marginLeft:'1vh',maxWidth:'10vw',marginTop:'4vh'
    },
    commenticonmob:{
        fontSize:'7vh',marginLeft:'1vh',marginTop:'1vh'
    },
    msgbox:{
        background: '#75b0e9',
        width:'65%',
        // minWidth:'50vw',
        // overflowY:'scroll',
        minHeight:'20vh',
        marginLeft:'2.5vh',
        padding:'1vh',
        overflowX:'hidden'
    
    },
    msgboxmob:{
        background: '#75b0e9',
        width:'100%',
        // minWidth:'50vw',
        // overflowY:'scroll',
        minHeight:'20vh',
        // marginLeft:'-2.3vh',
        padding:'1vh',
        overflowX:'hidden'
    
    },
    form:{
        display:'flex',
        flexDirection:'column'
       
    },
    formtext:{
        width:'100%',marginTop:'3vh',marginBottom:'3vh'
    },
    formtextmob:{
        width:'100%',marginTop:'3vh',marginBottom:'3vh'
    }


}))


function Comments({comment,key,id}) {
    const tokenString = sessionStorage.getItem('token');
    const dispatch = useDispatch();
    const userToken = JSON.parse(tokenString);
  
    const handleOnClick =(blog) =>{

   
        dispatch(deleteComment(id,comment._id))
        dispatch(getBlogs())

        // dispatch(deleteBlog(blog._id));
    
      }

    const match=useMediaQuery('(min-width:550px)')

    const classes=useStyles();

    return(
            <div className={match?classes.commentdiv:classes.commentdivmob}>
                <ReactFontLoader url='https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600&display=swap' />
                {match&&<AccountCircleIcon className={classes.commenticon}/>}

                <div className={match?classes.msgbox:classes.msgboxmob}>
                    {!match&&<AccountCircleIcon className={classes.commenticonmob} />}
                    <div style={{marginLeft:'1vw',marginTop:'1vh',marginRight:'1vw',marginBottom:'1vh'}}>
                    <Typography style={{fontFamily:'Rubik'}} variant='h6' >
                        {comment.name}
                    </Typography>
                    <Typography variant='body2' style={{color:'rgb(60,60,60)',fontFamily:'Rubik'}} >
                        {comment.email}
                    </Typography>
                    <Typography variant='subtitle2' style={{marginBottom:'2vh',fontFamily:'Rubik'}} >
                    {moment(comment.createdAt).fromNow()}
                    </Typography>
                    <Typography variant='body1' style={{marginRight:'1vw',fontFamily:'Rubik'}} >
                        {comment.body}
                    </Typography>
                    {userToken&&<IconButton onClick={()=>{handleOnClick(comment)}} edge="end" aria-label="delete">
                     <DeleteIcon />
                   </IconButton>}
                    </div>
                </div>
            </div>
    );
}



const Blogdetails = ({blogdetails}) => {
    const dispatch = useDispatch();
    const clear = () => {
        // setcurrentId(null);
        setcommentData({name: '', body: '', email: ''});
      };
    // useEffect(()=>{

    //     dispatch(getBlogs())
        
    //   })
    
    const {id}=useParams();


    const blogs = useSelector(state => state.blogs)

    const blog=blogs.filter((blo)=>blo._id===id)
  
    const [commentData, setcommentData] = useState({ name: '', body: '', email: ''});
    const [comment, setComment] = useState('')
    const [name, setName] = useState('')
    const [mail, setMail] = useState('')
    // const [comments,setComments]=useState(blog[0].comments)

    // const handleCommentChange=(e)=>{
    //     setComment(e.target.value)
    // }
    
    // const handleNameChange=(e)=>{
    //     setName(e.target.value)
    // }

    // const handleMailChange=(e)=>{
    //     setMail(e.target.value)
    // }


    const handleSubmit=(e)=>{
        e.preventDefault();

         if(commentData.name!==''&&commentData.body!==''&&commentData.email!==''){
             dispatch(updateBlog(blog[0]._id,commentData))
             clear();
        //     const newcomment={'name':name,'body':comment,'email':mail,'date':'1/2/20'}
        //      // const newArray =comments.slice();
        //     // newArray.push(newcomment)
        //     // // setComments(...comments,newcomment)

         }
        
        
    }

    const match=useMediaQuery('(min-width:550px)')
    

    const classes=useStyles();
    

    

    return ( 
        <Container style={{overflowX:'hidden',paddingTop:'3vh',paddingBottom:'3vh'}}>
            <ReactFontLoader url='https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600&display=swap' />
            {blog[0]?<div className={match?classes.rootdiv:classes.rootdivphone}>
 
            <div className={match?classes.adminIcon:classes.adminiconmobile}>
                <div style={{background:'#09417c',
                    padding:'0.8vh'}}>
                <AccountBoxIcon style={{fontSize:'8vh',color:'white'}}/>
                    <Typography variant='body1' style={{color:'white',fontFamily:'Rubik',marginLeft:'0.5vw',marginTop:'-1vh'}}>
                        Admin
                    </Typography>
                    </div>
                    <Typography style={{fontFamily:'Rubik'}} variant='subtitle2' >
                        {blog[0]&&moment(blog[0].createdAt).fromNow()}
                    {/* {moment(blog[0].createdAt).fromNow()} */}
                    </Typography>
            </div>

            <div className={classes.blogbody}>
            <Paper className={classes.bodypaper} >
                    <Typography variant='h5' style={{color:'black',fontFamily:'Rubik',marginLeft:'1vw',fontWeight:'600'}}>
                        {blog[0]&&blog[0].title}
                        {/* {blog[0].title} */}
                    </Typography>
                    <div style={{marginLeft:'1vw',marginTop:'1vh',marginRight:'1vw'}}>
                    <Typography variant='h6' style={{color:'black',fontFamily:'Rubik',textAllign:'center',fontWeight:'500'}}>
                    {blog[0]&&blog[0].summary}
                        {/* {blog[0].summary} */}
                    </Typography></div>
                    <div style={{marginLeft:'1vw',marginTop:'1vh',marginRight:'1vw'}}>
                    <Typography variant='body1' style={{color:'black',fontFamily:'Rubik',textAllign:'center'}}>
                    {blog[0]&&blog[0].body}
                        {/* {blog[0].body} */}
                    </Typography></div>

            </Paper>
            </div>
            </div>:<Loading></Loading>}
            
            <Container>
            {/* style={{color:'black',fontFamily:'Rubik',textAllign:'center',fontWeight:'500'}} */}
            <Typography variant='h5' style={{marginTop:'2vh',fontFamily:'Rubik',fontWeight:'500'}} >
                        <u>Comments({blog[0]&&blog[0].comments.length})</u>
                    </Typography>
                    {blog[0]&&blog[0].comments.map((comment,key)=><Comments id={blog[0]._id} comment={comment} key={key} />)}


                {/* {comments.map((comment,key)=><Comments comment={comment} key={key} />)} */}
                {/* <Comments/>
                <Comments/> */}
            <Typography variant='h5' style={{marginTop:'3vh',fontFamily:'Rubik',fontWeight:'500'}} >
                        <u>Leave Your Reply</u>
                    </Typography>
   
            </Container>
            
            <Container className={classes.form}>

                <form onSubmit={handleSubmit} >
                    <div>
                        <TextField
                        className={match?classes.formtext:classes.formtextmob}
                        required
                        id="comment-body"
                        label="Comment"
                        value={commentData.body}
                        name="body"
                        multiline
                        rows={5}
                        variant="outlined"
                        onChange={(e) => setcommentData({ ...commentData, body: e.target.value })}
                        />
                    </div>
                    <div>
                        <TextField
                        className={match?classes.formtext:classes.formtextmob}
                        required
                        id="comment-name"
                        value={commentData.name}
                        name="name"
                        label="Name"
                        variant="outlined"
                        onChange={(e) => setcommentData({ ...commentData, name: e.target.value })}
                        />
                    </div>
                    <div>
                        <TextField
                        className={match?classes.formtext:classes.formtextmob}
                        required
                        value={commentData.email}
                        id="comment-mail"
                        type='email'
                        name="email"
                        label="Email-ID"
                        variant="outlined"
                        onChange={(e) => setcommentData({ ...commentData, email: e.target.value })}
                        />
                    </div>
                    <Button type='submit' style={{background:'#09417c',color:'white',marginBottom:'4vh'}}>
                        Post
                    </Button>
                </form>
            </Container>

        </Container>

        
     );
}
 
export default Blogdetails;